var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section phone-section border-bottom-section" },
    [
      _c("div", { staticClass: "section-content" }, [
        _c("div", { staticClass: "columns is-valigned-end" }, [
          _c("div", { staticClass: "column is-narrow column-app-phone2" }, [
            _c("img", {
              staticClass: "block",
              attrs: {
                src: "/img/phone-it.png",
                alt: _vm.$t("alt.app"),
                draggable: "false",
              },
            }),
          ]),
          _c("div", { staticClass: "column column-app-phone1" }, [
            _c("p", { staticClass: "subtitle no-line-break-mobile" }, [
              _vm._v(_vm._s(_vm.$t("home.subtitle_l1"))),
            ]),
            _c("div", { staticClass: "alert-box" }, [
              _c("div", { staticClass: "has-text-centered" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "columns is-mobile is-centered is-vcentered is-multiline columns-no-padding-vertical margin-top-xs",
                  },
                  [
                    _c("div", { staticClass: "column is-narrow" }, [
                      _vm._v(_vm._s(_vm.$t("home.section_intro.app1"))),
                    ]),
                    _vm._m(0),
                    _c(
                      "div",
                      { staticClass: "column is-narrow no-padding-left" },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("home.section_intro.app2"))),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "column is-narrow no-padding-left" },
                      [_vm._v(_vm._s(_vm.$t("home.section_intro.app3")))]
                    ),
                  ]
                ),
                _vm._m(1),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow no-padding-left" }, [
      _c("img", {
        staticStyle: { width: "2.2rem", display: "block" },
        attrs: { src: "/icon.png", alt: "", draggable: "false" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-container margin-top-xs" }, [
      _c(
        "a",
        {
          staticStyle: { "max-width": "140px" },
          attrs: {
            href: "https://play.google.com/store/apps/details?id=com.fitnessdadivano.app",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: {
              src: "/img/google_play_badge.svg",
              alt: "Android",
              title: "Android",
            },
          }),
        ]
      ),
      _c(
        "a",
        {
          staticStyle: { "max-width": "140px" },
          attrs: {
            href: "https://itunes.apple.com/it/app/id1531130588?mt=8",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: {
              src: "/img/app_store_badge.svg",
              alt: "iOS",
              title: "iOS",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }